import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/outline";

import { Container } from "./container";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const details = {
  heading: {
    en: "Frequently asked questions",
    hi: "बार बार पूछे जाने वाले प्रश्न",
  },
  subHeading: {
    en: "If you can’t find what you’re looking for, email our support team and if you’re lucky someone will get back to you",
    hi: "यदि आपको वह नहीं मिल रहा है जिसकी आप तलाश कर रहे हैं, तो हमारी सहायता टीम को ईमेल करें और यदि आप भाग्यशाली हैं तो कोई आपसे संपर्क करेगा",
  },
};

const Faqs = ({ faqs, lang }) => {
  return (
    <section
      id="faq"
      aria-labelledby="faq-title"
      className="relative overflow-hidden bg-slate-50 py-10"
    >
      <Container className="relative">
        <div className="max-w-7xl mx-auto sm:py-16 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto divide-y-2 divide-gray-200">
            <h2
              id="faq-title"
              className="font-display text-xl lg:text-3xl tracking-tight text-slate-900"
            >
              {details["heading"][lang]}
            </h2>
            <p className="mt-5 text-md lg:text-lg tracking-tight text-slate-700">
              {details["subHeading"][lang]}
            </p>
            <dl className="mt-6 space-y-6 divide-y divide-gray-200">
              {faqs.map((faq, i) => (
                <Disclosure as="div" key={i} className="pt-6">
                  {({ open }) => (
                    <>
                      <dt className="text-base">
                        <Disclosure.Button className="text-left w-full flex justify-between items-start text-gray-400">
                          <span className="font-medium text-gray-900">
                            {faq.question}
                          </span>
                          <span className="ml-6 h-7 flex items-center">
                            <ChevronDownIcon
                              className={classNames(
                                open ? "-rotate-180" : "rotate-0",
                                "h-6 w-6 transform"
                              )}
                              aria-hidden="true"
                            />
                          </span>
                        </Disclosure.Button>
                      </dt>
                      <Disclosure.Panel as="dd" className="mt-2 pr-12">
                        <p className="text-base text-gray-500">{faq.answer}</p>
                      </Disclosure.Panel>
                    </>
                  )}
                </Disclosure>
              ))}
            </dl>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Faqs;
